import { createSlice } from '@reduxjs/toolkit';

import { customerDeliveryOrderByProductApi } from '@apis/customerDeliveryOrderByProduct/CustomerDeliveryOrderByProductApi';
import {
    materialsTransferByWarehouseApi,
    materialsTransferByWarehouseDefectiveApi
} from '@apis/materialsTransferByWarehouse/MaterialsTransferByWarehouse.api';
import {
    outboundOrderByWarehouseApi,
    outboundOrderByWarehouseDefectiveApi
} from '@apis/outboundOrderByWarehouse/OutboundOrderByWarehouse.api';
import { initialPaginationState } from '@constants/pagination';
import {
    MasterInitialState,
    PreCheckResponse
} from '@customTypes/api/api.types';
import { Pagination } from '@customTypes/general/general.types';
import { handleFulfilledPagination } from '@helpers/handleFulfilledPagination';
import { Action } from 'store/index';

export interface InitialPreCheckMaster extends MasterInitialState {
    data: PreCheckResponse['data']['items'];
}

export const initialPreCheckPagination: Pagination = {
    ...initialPaginationState,
    pageSize: 11
};

const initialState: InitialPreCheckMaster = {
    loading: false,
    pagination: initialPreCheckPagination,
    errors: { code: 0, message: '' },
    data: []
};

export const preCheckMasterSlice = createSlice({
    name: 'preCheckMaster',
    initialState,
    reducers: {
        editPagination(
            state,
            action: Action<
                Partial<Omit<Pagination, 'pagesCount' | 'totalItemsCount'>>
            >
        ) {
            state.pagination = {
                ...state.pagination,
                ...action.payload
            };
        },
        resetPagination(state) {
            state.pagination = initialPreCheckPagination;
        },
        resetPreCheckMaster() {
            return initialState;
        }
    },
    extraReducers: (builder) => {
        builder.addMatcher(
            customerDeliveryOrderByProductApi.endpoints.preCheckByProduct
                .matchFulfilled,
            handleFulfilledPagination
        );
        builder.addMatcher(
            outboundOrderByWarehouseApi.endpoints.preCheckByWarehouse
                .matchFulfilled,
            handleFulfilledPagination
        );
        builder.addMatcher(
            outboundOrderByWarehouseDefectiveApi.endpoints.preCheckByWarehouse
                .matchFulfilled,
            handleFulfilledPagination
        );
        builder.addMatcher(
            materialsTransferByWarehouseApi.endpoints
                .preCheckTransferByWarehouse.matchFulfilled,
            handleFulfilledPagination
        );
        builder.addMatcher(
            materialsTransferByWarehouseDefectiveApi.endpoints
                .preCheckTransferByWarehouse.matchFulfilled,
            handleFulfilledPagination
        );
    }
});

export const { editPagination, resetPagination, resetPreCheckMaster } =
    preCheckMasterSlice.actions;
